var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "view--presale-detail"
  }, [!_vm.loading ? _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "6"
    }
  }, [_c('b-card', [_c('b-card-title', [_vm._v("Resultaat")]), _vm.presale === null ? [_c('p', [_vm._v("De gegevens van deze presale ontbreken.")])] : [_c('b-table-simple', {
    attrs: {
      "small": ""
    }
  }, [_vm.presale.product_identifier !== null ? _c('b-tr', [_c('b-th', [_vm._v(" Productidentifier ")]), _c('b-td', [_vm._v(" " + _vm._s(_vm.presale.product_identifier) + " ")])], 1) : _vm._e(), _vm.presale.additional_identifier !== null ? _c('b-tr', [_c('b-th', [_vm._v(" Extra identifier ")]), _c('b-td', [_vm._v(" " + _vm._s(_vm.presale.additional_identifier) + " ")])], 1) : _vm._e(), _c('b-tr', [_c('b-th', [_vm._v(" Virtuele stock ")]), _c('b-td', [_vm.virtualStockIsEditable ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.presale.virtual_stock,
      expression: "presale.virtual_stock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "virtual_stock",
      "required": "required"
    },
    domProps: {
      "value": _vm.presale.virtual_stock
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.presale, "virtual_stock", $event.target.value);
      }
    }
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.presale.virtual_stock) + " ")])])], 1), _c('b-tr', [_c('b-th', [_vm._v(" Presale begint op ")]), _c('b-td', [_vm.presaleStartDateIsEditable ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.presale.presale_starts_at,
      expression: "presale.presale_starts_at"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "presale_starts_at",
      "required": "required"
    },
    domProps: {
      "value": _vm.presale.presale_starts_at
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.presale, "presale_starts_at", $event.target.value);
      }
    }
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.parseDate(_vm.presale.presale_starts_at)) + " ")])])], 1), _c('b-tr', [_c('b-th', [_vm._v(" Presale loopt tot ")]), _c('b-td', [_vm.presaleEndDateIsEditable ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.presale.presale_ends_at,
      expression: "presale.presale_ends_at"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "presale_ends_at",
      "required": "required"
    },
    domProps: {
      "value": _vm.presale.presale_ends_at
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.presale, "presale_ends_at", $event.target.value);
      }
    }
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.parseDate(_vm.presale.presale_ends_at)) + " ")])])], 1), _vm.presale.release_date !== null ? _c('b-tr', [_c('b-th', [_vm._v(" Release datum ")]), _c('b-td', [_vm.presaleReleaseDateIsEditable ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.presale.release_date,
      expression: "presale.release_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "release_date",
      "required": "required"
    },
    domProps: {
      "value": _vm.presale.release_date
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.presale, "release_date", $event.target.value);
      }
    }
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.parseDate(_vm.presale.release_date)) + " ")])])], 1) : _vm._e(), _c('b-tr', [_c('b-th', [_vm._v(" Aantal voorverkocht ")]), _c('b-td', [_vm._v(" " + _vm._s(_vm.presale.sold_quantity) + " ")])], 1), _c('b-tr', [_c('b-th', [_vm._v(" Aantal geannuleerd ")]), _c('b-td', [_vm._v(" " + _vm._s(_vm.presale.cancelled_quantity) + " ")])], 1)], 1), _c('div', {
    staticClass: "action-buttons"
  }, [_c('b-button', {
    on: {
      "click": _vm.cancelButtonHandler
    }
  }, [_vm.thereAreChanges && _vm.isEditable ? [_vm._v(" Annuleren ")] : [_vm._v(" Terug naar overzicht ")]], 2), _vm.thereAreChanges ? _c('b-button', {
    class: {
      'btn-success': _vm.thereAreChanges
    },
    attrs: {
      "disabled": !_vm.thereAreChanges
    },
    on: {
      "click": _vm.saveButtonHandler
    }
  }, [_vm._v(" Opslaan ")]) : _vm._e()], 1)]], 2)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }